<script setup>
import AppLayout from "@/components/AppLayout.vue";

import {useRoute, useRouter} from "vue-router";
const route = useRoute();
const router = useRouter();
const isAppPage = computed(() => route.meta?.layout !== 'guest');
</script>

<template>
    <div class="relative">
        <ConfirmDialog></ConfirmDialog>
        <Toast />

        <app-layout v-if="isAppPage">
            <router-view />
        </app-layout>

        <router-view v-else />
    </div>
</template>
